import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import visits from 'modules/posts/store/collections/visits'

interface ReturnType {
  loadingVisit: boolean
}

const useVisitsFindOrCreate = (post_id: number): ReturnType => {
  const { loading: loadingVisit } = useAsyncData(async () => {
    if (!post_id) return false

    await visits
      .rpc('find_or_create', {
        post_id: post_id,
      })
      .catch(() => Promise.resolve(false))
  }, [post_id])

  return {
    loadingVisit,
  }
}

export default useVisitsFindOrCreate
